<script setup lang="ts">
import type { Handicap } from '~/types/hotmatch'

defineProps({
  handicap: {
    type: Object as () => Handicap,
    default: null,
  },
  rate: {
    type: String,
    default: null,
  },
  isHiddenRate: {
    type: Boolean,
    default: false,
  },
})
const SCORE_HIGHT_LIGHT = 0.9
const isNegativeNumber = (value: string): boolean => {
  const parsedValue = parseFloat(value)
  return (
    (!isNaN(parsedValue) && parsedValue < - SCORE_HIGHT_LIGHT) ||
    (!isNaN(parsedValue) && parsedValue >= SCORE_HIGHT_LIGHT)
  )
}
</script>
<template>
  <div class="handicap" :class="{ handicap__empty: !handicap }">
    <template v-if="handicap?.odds">
      <div v-if="!isHiddenRate" class="handicap__rate">{{
        rate ?? handicap.rate
      }}</div>
      <div
        class="handicap__odds"
        :class="{ handicap__negative: isNegativeNumber(handicap.odds) }"
        >{{ handicap.odds }}</div
      >
    </template>
    <div v-else class="handicap__empty-txt">--</div>
  </div>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/base/handicap.scss';
</style>
